package app.footyguide.web.components.club

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.css.*
import app.footyguide.core.locale.AppStrings

/**
 * Sub-tabs row for switching between Overview, Calendar and Standings.
 */
@Composable
fun ClubSubTabsRow(
    activeTab: ClubSubTab,
    onTabSelected: (ClubSubTab) -> Unit,
    strings: AppStrings
) {
    Div({
        style {
            margin(12.px, 16.px, 16.px)
            display(DisplayStyle.Flex)
            backgroundColor(Color("#FFFFFF"))
            border(1.px, LineStyle.Solid, Color("#E7E7E1"))
            borderRadius(12.px)
            padding(4.px)
            gap(4.px)
        }
    }) {
        ClubSubTab.entries.forEach { tab ->
            val isSelected = activeTab == tab
            Button({
                onClick { onTabSelected(tab) }
                style {
                    flex(1)
                    padding(8.px, 0.px)
                    backgroundColor(Color(if (isSelected) "#16181D" else "transparent"))
                    color(Color(if (isSelected) "#FFFFFF" else "#71717A"))
                    border(0.px)
                    borderRadius(8.px)
                    fontFamily("Sora, 'Plus Jakarta Sans', sans-serif")
                    fontSize(12.px)
                    fontWeight(if (isSelected) 700 else 600)
                    cursor("pointer")
                    property("transition", "all 0.15s ease")
                }
            }) {
                Text(tab.getDisplay(strings))
            }
        }
    }
}
